module.exports = __webpack_public_path__ + "static/media/little_victory_2_filter.7f47d7be.png";